module.exports = __webpack_public_path__ + "media/app/google-play-badge-it-05b4c257.svg";